import {Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivityType, TalentProfilePage } from "../../../enums";
import { PageService} from "../shared/page-service";
import { TalentProfileApiService } from "../talent-profile-api.service";
import { TalentMoatsMoney } from "../../../../typings";
import { getCurrencySymbol } from "@angular/common";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { sendDoThisLaterEmail } from "../../shared/util/talent-happy-path-util";

@Component({
    selector: 'app-employment-salary',
    templateUrl: './employment-salary.component.html',
    styleUrl: './employment-salary.component.scss',
    standalone: false
})
export class EmploymentSalaryComponent implements  OnInit {
  salaryForm: FormGroup;
  isInitialLoad: boolean = false;
  currencySymbol: string;
  talentSalary: TalentMoatsMoney;
  talent: Talent;
  posting: PostingInfo;
  isModalVisible: boolean = false;
  hasSalaryError: boolean = false;
  hasHourlyError: boolean = false;

  @Input() fromNotAFit: boolean = false;

  constructor(
    private fb: FormBuilder,
    private pageService: PageService,
    private talentProfileApiService: TalentProfileApiService,
    private talentHappyPathDataService: TalentHappyPathDataService
  ) {}

  ngOnInit(): void {
    this.salaryForm = this.fb.group({
      minimumHourlyRate: [null],
      desiredHourlyRate: [null],
      minimumYearlySalary: [null],
      desiredYearlySalary: [null],
    });
    this.talent = this.talentHappyPathDataService.talent;
    this.posting = this.talentHappyPathDataService.postingInfo;
    this.loadSalary();
    this.getCurrencyCode();

    this.salaryForm.valueChanges.subscribe(values => this.onSalaryFormValueChanges(values));
  }


  private onSalaryFormValueChanges(values: any): void {
    this.hasHourlyError = false;
    this.hasSalaryError = false;
    const formattedValues = {
      desiredHourlyRate: this.convertStringToNumber(values.desiredHourlyRate),
      desiredYearlySalary: this.convertStringToNumber(values.desiredYearlySalary),
      minimumYearlySalary: this.convertStringToNumber(values.minimumYearlySalary),
      minimumHourlyRate: this.convertStringToNumber(values.minimumHourlyRate)
    };

    this.talentSalary = formattedValues;

    if (formattedValues.desiredHourlyRate && formattedValues.minimumHourlyRate && formattedValues.desiredHourlyRate < formattedValues.minimumHourlyRate) {
      this.salaryForm.controls['minimumHourlyRate'].setErrors({['rateError']:true});
      this.hasHourlyError = true;
    } else {
      this.salaryForm.controls['minimumHourlyRate'].setErrors(null);
    }

    if (formattedValues.desiredYearlySalary && formattedValues.minimumYearlySalary && formattedValues.desiredYearlySalary < formattedValues.minimumYearlySalary) {
      this.salaryForm.controls['minimumYearlySalary'].setErrors({['salaryError']:true});
      this.hasSalaryError = true;
    } else {
      this.salaryForm.controls['minimumYearlySalary'].setErrors(null);
    }
  }

  private convertStringToNumber(str: string): number | null {
    return str ? Number(str.replace(/,/g, '')) : null;
  }

  private loadSalary(): void {
    this.talentProfileApiService.getEmploymentSalary(this.talent.personId).subscribe(salary => {
      this.talentSalary = { ...salary };
      this.salaryForm.patchValue(this.formatSalaryForForm(salary));
      this.isInitialLoad = false;
    });
  }

  private formatSalaryForForm(salary: any): any {
    return {
      minimumHourlyRate: this.formatNumberToString(salary.minimumHourlyRate),
      desiredHourlyRate: this.formatNumberToString(salary.desiredHourlyRate),
      minimumYearlySalary: this.formatNumberToString(salary.minimumYearlySalary),
      desiredYearlySalary: this.formatNumberToString(salary.desiredYearlySalary),
    };
  }

  private formatNumberToString(value: number | null): string {
    return value !== null ? value.toString() : '';
  }

  saveSalary(): void {
    this.talentProfileApiService.saveEmploymentSalary(this.talentSalary, this.talent.personId).subscribe(response => {
      console.log('Salary saved', response);
    }, error => {
      console.error('Error saving salary', error);
    });
    this.goToEmploymentAuthorization();
  }

  getCurrencyCode(): void {
    this.talentProfileApiService.getCurrencyCode(this.talent.personId).subscribe(response => {
      this.currencySymbol = getCurrencySymbol(response, 'narrow')
    }, error => {
      console.error('Error getting currency code', error);
    });
  }

  goToEmploymentPreferences() {
    this.pageService.setActivePage(TalentProfilePage.EMPLOYMENT_PREFERENCES);
  }

  goToEmploymentAuthorization() {
    this.pageService.setActivePage(TalentProfilePage.EMPLOYMENT_AUTHORIZATION);
  }

  doThisLater() {
    if (!this.talentHappyPathDataService.doThisLaterEmailSent) {
      sendDoThisLaterEmail(
        this.posting?.jobPostingId ?? null,
        this.talent.personId,
        this.talent.firstName,
        this.talent.lastName,
        this.talent.email,
        this.posting?.jobTitle ?? null,
        this.posting?.orderId ?? null,
        this.talentProfileApiService,
        this.talentHappyPathDataService.isGeneralApplication
      )
    }
  }

}
